import { combineReducers } from "redux"
import {
  routerReducer
} from "react-router-redux";

import user from "./userReducer"
import otherUser from "./otherUserReducer"
import appointment from "./appointmentReducer"
import newAppointment from "./newAppointmentReducer"
import updateAppointment from "./updateAppointmentReducer"
import deleteAppointment from "./deleteAppointmentReducer"
import calendar from "./calendarReducer"
import snackbar from "./snackbarReducer"
import settings from "./settingsReducer"
import week from "./weekReducer"
import { i18nReducer } from 'react-redux-i18n'

export default combineReducers({
  user,
  otherUser,
  appointment,
  newAppointment,
  updateAppointment,
  deleteAppointment,
  calendar,
  snackbar,
  settings,
  week,
  router: routerReducer,
  i18n: i18nReducer
})



// WEBPACK FOOTER //
// ./src/js/reducers/index.js